import { render, staticRenderFns } from "./SuggestedResourcesModalV2.vue?vue&type=template&id=456aaa68&scoped=true"
import script from "./SuggestedResourcesModalV2.vue?vue&type=script&lang=ts"
export * from "./SuggestedResourcesModalV2.vue?vue&type=script&lang=ts"
import style0 from "./SuggestedResourcesModalV2.vue?vue&type=style&index=0&id=456aaa68&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "456aaa68",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('456aaa68')) {
      api.createRecord('456aaa68', component.options)
    } else {
      api.reload('456aaa68', component.options)
    }
    module.hot.accept("./SuggestedResourcesModalV2.vue?vue&type=template&id=456aaa68&scoped=true", function () {
      api.rerender('456aaa68', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/requests/SuggestedResourcesModalV2.vue"
export default component.exports